module.exports = "/static/assets/666cc9d42862c4dedf91e0885ad79267.png";